var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNationwideLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 963.86,
    height: 383.361,
    viewBox: "0 0 963.86 383.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M0,250.028H958.4V-133.333H0Z",
    transform: "translate(0 133.333)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(0 133.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(0 -133.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(18.054 119.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M79.146,0,70.111,48.629C66.453,68.426,64.3,82.407,64.088,97.9h-.652C58.92,78.321,54.19,60.893,47.945,42.174L33.745,0H-14.881L-42.207,145.022H-5.845l8.392-44.968c4.3-22.806,8.392-44.754,9.895-59.172H13.3c4.949,19.8,10.332,36.147,16.784,55.944l13.728,41L91.84,126.766,115.727,0Z",
    transform: "translate(42.207)",
    fill: "#284393"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(104.076 112.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M1.573,11.906H43.746L47.185-6.349-.839,4.707Z",
    transform: "translate(0.839 6.349)",
    fill: "#d22027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(191.89 92.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M0,24.73H103.281L109.3-7.545H44.539L45.6-13.188,5.4-3.93Z",
    transform: "translate(0 13.188)",
    fill: "#d22027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(197.289 -14.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M66.365,57.116l6.241-32.275h-58.1l4.3-23.025H80.35l6.241-32.275H-13.462L-35.391,85.9l40.2-9.254L8.485,57.116Z",
    transform: "translate(35.391 30.459)",
    fill: "#284393"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(365.298 51.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M0,51.891H38.3L53.084-27.672,13.073-18.464Z",
    transform: "translate(0 27.672)",
    fill: "#d22027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(345.932 -14.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M78.166,21.332l6.241-32.708H-35.228l-6.456,32.708H-1.446L-9.244,63.3l40.011-9.212,6.088-32.751Z",
    transform: "translate(41.684 11.376)",
    fill: "#284393"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(18.052 -14.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M17.822,0h9.442L-.993,144.911l-8.511.111Z",
    transform: "translate(9.504)",
    fill: "#284393"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(45.377 -14.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M5.9,94.583,32.167-50.439h-9.1L-3.144,94.583Z",
    transform: "translate(3.144 50.439)",
    fill: "#284393"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(376.964 51.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M.918,6.008,40.929-3.2,39.518,4.39-.489,13.583Z",
    transform: "translate(0.489 3.204)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(376.964 51.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M.918,6.008,40.929-3.2,39.518,4.39-.489,13.583Z",
    transform: "translate(0.489 3.204)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.289
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(195.881 92.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M27.138,0l-40.2,9.254-1.411,7.483L34.05,5.643H26.076Z",
    transform: "translate(14.472)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(195.881 92.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M27.138,0l-40.2,9.254-1.411,7.483L34.05,5.643H26.076Z",
    transform: "translate(14.472)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.289
  })), /*#__PURE__*/React.createElement("g", {
    id: "g68",
    transform: "translate(104.076 112.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M0,7.211l2.246,6.7L46.6,3.734l1.426-7.579Z",
    transform: "translate(0 3.845)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "translate(104.076 112.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M0,7.211l2.246,6.7L46.6,3.734l1.426-7.579Z",
    transform: "translate(0 3.845)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.289
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76",
    transform: "translate(26.566 -14.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M18.427,0H35.2L8.985,145.022l-18.812-.111Z",
    transform: "translate(9.827)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g80",
    transform: "translate(26.566 -14.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "M18.427,0H35.2L8.985,145.022l-18.812-.111Z",
    transform: "translate(9.827)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.116
  })), /*#__PURE__*/React.createElement("g", {
    id: "g84",
    transform: "translate(54.953 -7.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M2.178,0h6.9L5.628,16.028H-1.161Z",
    transform: "translate(1.161)",
    fill: "#d22027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g88",
    transform: "translate(48.587 22.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M2.178,0h6.9L5.628,16.028H-1.161Z",
    transform: "translate(1.161)",
    fill: "#d22027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g92",
    transform: "translate(43.467 49.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M2.178,0h6.9L5.628,16.028H-1.161Z",
    transform: "translate(1.161)",
    fill: "#d22027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96",
    transform: "translate(38.348 77.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M2.178,0h6.9L5.628,16.028H-1.161Z",
    transform: "translate(1.161)",
    fill: "#d22027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g100",
    transform: "translate(32.963 107.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M2.178,0h6.9L5.628,16.028H-1.161Z",
    transform: "translate(1.161)",
    fill: "#d22027"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text108",
    transform: "translate(487.86 37.505)",
    fill: "#d22027",
    fontSize: 43,
    fontFamily: "Helvetica-BoldOblique, Helvetica",
    fontWeight: 700,
    fontStyle: "oblique"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Nationwide Equipment "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 69
  }, "Transportation Inc.")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationwideLogo);
export default __webpack_public_path__ + "static/media/Nationwide-Logo.4cd1886868b64938bf20f7a0467c6680.svg";
export { ForwardRef as ReactComponent };